import { origin } from './snippet.js';

/**
 * Injects everything the launcher and its bubble need into <head>, once. The launcher's own styles are
 * inlined (they animate identically to the Blazor AnimatedSparkles component — keep the two in step);
 * the bubble's look and the launcher's pulse halo are linked from leadwin-nudge.css, the single copy
 * the manage panel's preview reads as well.
 *
 * The sparkles only turn. Breathing them down to 82% and .6 halfway through read as the mark going
 * dark rather than as a pulse; the pulse belongs to the halo outside the circle, where it does not sit
 * on top of anything.
 */
export function injectSparkleStyles() {
    injectNudgeStyles();

    if (document.getElementById('lw-sparkle-styles')) {
        return;
    }
    const style = document.createElement('style');
    style.id = 'lw-sparkle-styles';
    style.textContent =
        /* Cards and bubbles stay invisible until leadwin-nudge.css has arrived. A surface built before
         * it lands would flash as bare page text for a moment (a trust card read as one long line of
         * stars and quote). :where keeps this at zero specificity, so the stylesheet's own
         * visibility:visible wins the moment it loads, whichever order the two ended up in. */
        ':where(.lw-trust-corner,.lw-nudges,.lw-announcement-backdrop){visibility:hidden}' +
        '@keyframes lwSparkleSpin{' +
            '0%{transform:rotate(0deg)}' +
            '25%,100%{transform:rotate(360deg)}' +
        '}' +
        '#leadwin-agent-button .lw-sp-l,' +
        '#leadwin-agent-button .lw-sp-m,' +
        '#leadwin-agent-button .lw-sp-s{' +
            'transform-box:fill-box;transform-origin:center;' +
            'animation:lwSparkleSpin 5s ease-in-out infinite;' +
            'will-change:transform' +
        '}' +
        '#leadwin-agent-button .lw-sp-m{animation-delay:1700ms;animation-duration:5.8s}' +
        '#leadwin-agent-button .lw-sp-s{animation-delay:3300ms;animation-duration:6.5s}' +
        '#leadwin-agent-button{transition:transform .16s ease}' +
        '#leadwin-agent-button:hover{transform:scale(1.1)}' +
        '#leadwin-agent-button:active{transform:scale(.9)}' +
        /* The panel's loading dots: what the visitor watches while the chat document is still on its
         * way (first open, recovery remount, language remount). The iframe fades in OVER them once its
         * document painted — see surface-frame's setFrameLoading. Mid-grey via currentColor, readable
         * on both looks of the panel ground. */
        '@keyframes lwPanelDot{0%,80%,100%{opacity:.25;transform:scale(.85)}40%{opacity:1;transform:scale(1)}}' +
        '#leadwin-agent-loading{position:absolute;inset:0;display:flex;align-items:center;' +
            'justify-content:center;gap:6px;pointer-events:none}' +
        '#leadwin-agent-loading span{width:8px;height:8px;border-radius:9999px;background:currentColor;' +
            'animation:lwPanelDot 1.2s ease-in-out infinite}' +
        '#leadwin-agent-loading span:nth-child(2){animation-delay:.15s}' +
        '#leadwin-agent-loading span:nth-child(3){animation-delay:.3s}';
    document.head.appendChild(style);
}

/**
 * Links the bubble's look. A stylesheet rather than another inlined string because the manage panel's
 * preview loads the very same file: two copies of these numbers is what made the preview wrap a line
 * earlier than the real bubble did.
 */
function injectNudgeStyles() {
    if (document.getElementById('lw-nudge-styles')) {
        return;
    }

    const link = document.createElement('link');
    link.id = 'lw-nudge-styles';
    link.rel = 'stylesheet';
    link.href = origin + '/widget/leadwin-nudge.css';
    document.head.appendChild(link);
}
